module.exports = __webpack_public_path__ + "static/media/Learn-Responding-to-pressure-01.22bc79a5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Learn-Responding-to-pressure-01.mp3
// module id = 578
// module chunks = 0